document.addEventListener('DOMContentLoaded', function() {
  const keyFeaturesList = document.querySelector('.key-features-list');

  if (keyFeaturesList) {
    const ulElement = keyFeaturesList.querySelector('ul');
    ulElement.style.display = 'flex';
    ulElement.style.flexDirection = 'column';
    ulElement.style.gap = '10px'; 

    const listItems = keyFeaturesList.querySelectorAll('li');
    const iconPath = 'https://cdn-icons-png.flaticon.com/256/5610/5610944.png';

    listItems.forEach(li => {
      // Check if li has text content (trim whitespace)
      if (li.textContent.trim() === '') {
        return; // Skip this li if it's empty
      }

      const icon = document.createElement('img');
      icon.src = iconPath;
      icon.alt = 'Icon';
      icon.style.width = '20px';
      icon.style.height = '20px'; 
      icon.style.marginRight = '8px';

      // Add flexbox styles to the li element
      li.style.display = 'flex';
      li.style.alignItems = 'center';

      // Prepend the icon to the li element
      li.prepend(icon);
    });
  } else {
    console.log('Key features list not found');
  }
});